import React from "react"
import SEO from "../components/seo"
import Layout from "../components/layout/layout"
import PageTitle from "../components/page-title"
import { Container, Row } from "reactstrap"
import SIDEORDER from "../components/menu/catering/sideorder"
import MEATS from "../components/menu/catering/meats"
import SALADS from "../components/menu/catering/salads"
import LARGEPARTY from "../components/menu/catering/large-party"
import DONTFORGET from "../components/menu/catering/dontforget"
import MenuPdf from "../pdf/Ribs-Usa-Menu.pdf"

const CateringMenu = () => {
  return (
    <Layout>
      <SEO
        title="Catering Menu"
        keywords="ribsusabbq, ribs usa, ribs usa bbq, ribs, usa, bbq, best bbq near me, baby back ribs, beef ribs near me, best beef ribs near me, bbq chicken near me"
      />
      <PageTitle title="Catering Menu" />
      <section id="list-menu">
        <Container>
          <Row className="up-menu">
            <div className="col-12 col-sm-12">
              <div className="text-center">
                <a
                  className="btn my-button"
                  rel="noopener noreferrer"
                  target="_blank"
                  href={MenuPdf}
                  download
                >
                  <span className="myover">Download Our Menu</span>
                </a>
              </div>
            </div>
          </Row>
          <Row>
            <div className="item-show col-md-6 col-sm-12">
              <LARGEPARTY />
              <SIDEORDER />
            </div>
            <div className="item-show col-md-6 col-sm-12">
              <SALADS />
              <MEATS />
              <DONTFORGET />
            </div>
          </Row>
        </Container>
      </section>
    </Layout>
  )
}

export default CateringMenu
